import { useEffect, useRef, useState } from 'react'

import { type BadgeValueType } from './types'

export function useDirtyState<T> (badgeValues: BadgeValueType<T>[]) {
  const [isDirty, setIsDirty] = useState(false)
  const initialValuesRef = useRef(badgeValues)

  useEffect(() => {
    if (initialValuesRef.current !== badgeValues) {
      setIsDirty(true)
    }
  }, [badgeValues])

  return isDirty
}
